/* eslint-disable no-undef */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN || 'http://localhost:8000';
export const BASE_PATH = process.env.REACT_APP_BASE_PATH || '/';